var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificon01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6614 6.66455H3.33233C2.87224 6.66455 2.49927 7.03753 2.49927 7.49762V9.16375C2.49927 9.62384 2.87224 9.99682 3.33233 9.99682H16.6614C17.1215 9.99682 17.4945 9.62384 17.4945 9.16375V7.49762C17.4945 7.03753 17.1215 6.66455 16.6614 6.66455Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99683 6.66455V17.4944",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8282 9.99683V15.8283C15.8282 16.2702 15.6527 16.694 15.3402 17.0064C15.0278 17.3189 14.604 17.4944 14.1621 17.4944H5.83142C5.38953 17.4944 4.96574 17.3189 4.65328 17.0064C4.34082 16.694 4.16528 16.2702 4.16528 15.8283V9.99683",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24795 6.66454C5.69559 6.66454 5.16586 6.44511 4.77528 6.05454C4.38471 5.66396 4.16528 5.13423 4.16528 4.58187C4.16528 4.02951 4.38471 3.49978 4.77528 3.1092C5.16586 2.71863 5.69559 2.4992 6.24795 2.4992C7.0516 2.4852 7.83913 2.87513 8.50784 3.61815C9.17655 4.36116 9.69541 5.42277 9.99675 6.66454C10.2981 5.42277 10.8169 4.36116 11.4857 3.61815C12.1544 2.87513 12.9419 2.4852 13.7455 2.4992C14.2979 2.4992 14.8276 2.71863 15.2182 3.1092C15.6088 3.49978 15.8282 4.02951 15.8282 4.58187C15.8282 5.13423 15.6088 5.66396 15.2182 6.05454C14.8276 6.44511 14.2979 6.66454 13.7455 6.66454",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificon01);
export default __webpack_public_path__ + "static/media/notificon01.5181dc405a1a1abbead3858b21294bca.svg";
export { ForwardRef as ReactComponent };